/**
 * DF compare : comparateur avant / après
 *
 * Glisser (souris ou doigt) ou utiliser les flèches du clavier sur la poignée pour déplacer le curseur.
 * Les événements sont délégués sur le document : ça fonctionne aussi pour un comparateur placé dans un onglet
 * masqué ou ajouté après coup. Sur mobile, le défilement vertical de la page reste possible (touch-action: pan-y).
 */
(function () {
  if (window.__dfCompareInit) return;
  window.__dfCompareInit = true;

  var active = null;

  function setPos(el, pct) {
    pct = Math.max(0, Math.min(100, pct));
    el.style.setProperty('--pos', pct + '%');
    var handle = el.querySelector('.df-compare__handle');
    if (handle) handle.setAttribute('aria-valuenow', String(Math.round(pct)));
  }

  function posFromEvent(el, e) {
    var rect = el.getBoundingClientRect();
    if (!rect.width) return 50;
    return ((e.clientX - rect.left) / rect.width) * 100;
  }

  document.addEventListener('pointerdown', function (e) {
    var el = e.target.closest ? e.target.closest('.df-compare') : null;
    if (!el) return;
    if (e.pointerType === 'mouse' && e.button !== 0) return;

    active = el;
    el.classList.add('is-dragging');
    try { el.setPointerCapture(e.pointerId); } catch (err) {}
    setPos(el, posFromEvent(el, e));
  });

  document.addEventListener('pointermove', function (e) {
    if (!active) return;
    setPos(active, posFromEvent(active, e));
  });

  function endDrag() {
    if (!active) return;
    active.classList.remove('is-dragging');
    active = null;
  }

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  document.addEventListener('keydown', function (e) {
    var handle = e.target.closest ? e.target.closest('.df-compare__handle') : null;
    if (!handle) return;

    var el = handle.closest('.df-compare');
    if (!el) return;

    var current = parseFloat(getComputedStyle(el).getPropertyValue('--pos'));
    if (isNaN(current)) current = 50;
    var step = e.shiftKey ? 10 : 2;

    if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
      e.preventDefault();
      setPos(el, current - step);
    } else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
      e.preventDefault();
      setPos(el, current + step);
    } else if (e.key === 'Home') {
      e.preventDefault();
      setPos(el, 0);
    } else if (e.key === 'End') {
      e.preventDefault();
      setPos(el, 100);
    }
  });
})();
